import React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';

import { Alert, Box, TextField, Typography } from '@mui/material';

import Autocomplete from '@mui/material/Autocomplete';

import { Organisation } from '../../organisation';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>;
  organisation: Organisation | undefined;
  organisations: Organisation[];
  setOrganisation: React.Dispatch<React.SetStateAction<Organisation | undefined>>;
  validate: () => void;
}

const StepOrganisationAssignment = ({ classes, organisation, organisations, setOrganisation, validate }: Props): React.ReactElement => {
  return (
    <>
      <div className={classes.root}>
        <Typography className={classes.header} variant="h4">
          Organisation
        </Typography>
        {organisations.length === 1 && organisation && <Alert severity="info">You are assigned to one organisation only, which has been automatically selected.</Alert>}
        {organisations.length > 1 && <Alert severity="info">You are assigned to more than one organisation. Please select the one you are sending this case from</Alert>}
        <Box mt={2}>
          <Autocomplete
            data-qa="organisation-assignment-list"
            options={organisations}
            disabled={organisations.length === 1}
            getOptionLabel={(option: Organisation) => option.name}
            value={organisations.find((i) => i.id === organisation?.id)}
            autoComplete
            onBlur={() => validate()}
            onChange={(_: unknown, newValue: Organisation | null) => {
              setOrganisation(newValue || undefined);
            }}
            renderInput={(params) => (
              <TextField
                data-qa="organisation-assignment-input"
                {...params}
                label="Organisation assignment"
                name="organisation-assignment"
                helperText={organisation ? '' : 'Select an organisation'}
              />
            )}
          />
        </Box>
      </div>
    </>
  );
};

export default withStyles(styles)(StepOrganisationAssignment);
